/**
 * Created by Denis Kuzin on 15 may 2024
 */

const ColorComponent = function (cell, color) {
    this.cell = cell;
    this.color = color === "" ? undefined : color;
};

ColorComponent.prototype.useCustomView = function () {
    return false;
};

ColorComponent.prototype.onDoubleTouch = function () {
    if (cleverapps.config.debugMode) {
        const action = function (shapeName) {
            const options = {};

            if (shapeName) {
                options.shapeName = shapeName;
            } else {
                options.random = true;
            }

            const combo = ComboComponent.Create(this.cell, options);

            if (combo && !Game.currentGame.counter.isActive()) {
                this.cell.delete();
                Game.currentGame.field.addCell(combo);
                combo.animate(BaseCell.ANIMATION_CREATE);
            }
        }.bind(this);

        if (cleverapps.gameModes.newRules) {
            this.view.debugShowTypesList(
                [
                    { shapeName: Shape.PLANE, text: "plane" },
                    { shapeName: Shape.FOUR_V, text: "rocket ver." },
                    { shapeName: Shape.FOUR_H, text: "rocket hor." },
                    { shapeName: Shape.BOMB, text: "bomb" }
                ],
                action
            );
        } else {
            action();
        }
    }
};

ColorComponent.prototype.setColor = function (color) {
    this.color = color;
};

ColorComponent.prototype.canRepaint = function () {
    return true;
};

ColorComponent.prototype.canDelete = function () {
    return this.cell.constructor === BaseCell && !this.cell.toDelete;
};

ColorComponent.prototype.repaint = function () {
    return Game.currentGame.field.loader.loadNext(this.cell.y, this.cell.x, [Loader.WILDCARD]);
};

ColorComponent.prototype.boomNeighbors = function (coef) {
    if (!this.cell.alive) {
        return;
    }

    this.cell.forNeighbor((neighbor) => {
        neighbor.boom(coef, this.cell);
    });
};

ColorComponent.prototype.explodeViaEater = function (eater, params) {
    if (!this.cell.alive) {
        return;
    }
    this.cell.alive = false;

    params = params || {};
    if (!params.groupSize) {
        params.groupSize = 1;
    }
    if (!params.id) {
        params.id = 0;
    }

    const goal = eater.findComponent(EaterComponent).check(this.cell, params.id, params.groupSize);
    this.cell.onBeforeExplodeMouseListener(eater, goal, params.id);

    // different time, because we don't want to wait for collect animation to finish
    const EXPLODE_INTERVAL = this.cell.explodeDuration();
    Game.currentGame.counter.setTimeout(this.cell.afterExplode.bind(this.cell, params.callback), EXPLODE_INTERVAL * 1000);
};

ColorComponent.prototype.simpleExplode = function (params) {
    const eater = EaterComponent.find(params, this.color);
    if (eater) {
        this.explodeViaEater(eater, params);
        return;
    }

    return true;
};

ColorComponent.prototype.explode = function (params) {
    cleverapps.eventBus.trigger("taskEvent", "COLLECT_COLOR_CELLS", { color: this.color.toLowerCase() });
    cleverapps.eventBus.trigger("collect_color_cells", { color: this.color.toLowerCase() });

    this.cell.simpleExplode(params);
};

ColorComponent.prototype.load = function (data) {
    this.color = data.shift();

    const markComponent = this.cell.findComponent(MarkComponent);
    if (markComponent) {
        markComponent.load(data);
    }
};

ColorComponent.prototype.save = function () {
    const markComponent = this.cell.findComponent(MarkComponent);
    const markCode = markComponent && markComponent.save();
    if (markCode) {
        return [this.color, markCode];
    }

    return [this.color];
};

ColorComponent.prototype.getViewClass = function () {
    if (this.color === "a") {
        // eslint-disable-next-line camelcase
        return ColorCellView_a;
    }
    if (this.color === "b") {
        // eslint-disable-next-line camelcase
        return ColorCellView_b;
    }
    if (this.color === "c") {
        // eslint-disable-next-line camelcase
        return ColorCellView_c;
    }
    if (this.color === "d") {
        // eslint-disable-next-line camelcase
        return ColorCellView_d;
    }
    if (this.color === "e") {
        // eslint-disable-next-line camelcase
        return ColorCellView_e;
    }
    if (this.color === "w") {
        // eslint-disable-next-line camelcase
        return ColorCellView_w;
    }
    throw `unknown color: ${this.color}`;
};

ColorComponent.COLOR_A = "a";
ColorComponent.COLOR_B = "b";
ColorComponent.COLOR_C = "c";
ColorComponent.COLOR_D = "d";
ColorComponent.COLOR_E = "e";
ColorComponent.COLOR_W = "w";

ColorComponent.CODE_COLORS = {};
ColorComponent.CODE_COLORS[ColorComponent.COLOR_A] = "blue";
ColorComponent.CODE_COLORS[ColorComponent.COLOR_B] = "green";
ColorComponent.CODE_COLORS[ColorComponent.COLOR_C] = "purple";
ColorComponent.CODE_COLORS[ColorComponent.COLOR_D] = "red";
ColorComponent.CODE_COLORS[ColorComponent.COLOR_E] = "yellow";
ColorComponent.CODE_COLORS[ColorComponent.COLOR_W] = "white";
